export default [
    {
        path: 'beneficios/liberar',
        component: require('./gestao/ReadLiberacao').default,
        meta: {
            middleware: 'auth',
            controller: 'BeneficioController'
        }
    },   
    {
        path: 'beneficios',
        component: require('./gestao/Read').default,
        meta: { middleware: 'auth', controller: 'BeneficioController' }
    },
    {
        path: 'beneficio/edit/:id',
        component: require('./gestao/Edit').default,
        meta: { middleware: 'auth', controller: 'BeneficioController' },
    },
    {
        path: 'familia/beneficios/:id',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'BeneficioFamiliaController' }
    },
    {
        path: 'familia/beneficio/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'BeneficioFamiliaController' },
    },
    {
        path: 'familia/beneficio/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'BeneficioFamiliaController'
        }
    },
    {
        path: 'relatorios/beneficios',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/beneficios/home',
        meta: { middleware: 'auth', controller: 'RelatorioBeneficioController' },
        children: [{
            path: 'home',
            name: 'relatorios_home_beneficios',
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioBeneficioController' },
        }, {
            path: 'graficos',
            name: 'graficos_beneficios',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioBeneficioController' },
        }, {
            path: 'concessoes',
            name: 'relatorios_concessoes_beneficios',
            component: require('./reports/includes/Concessoes').default,
            meta: { middleware: 'auth', controller: 'RelatorioBeneficioConcessoesController' },
        },
        ]
    },  
    {
        path: 'beneficios/entrega',
        component: require('./entrega/Read').default,
        meta: {
            middleware: 'auth',
            controller: 'BeneficioController'
        }
    },
];


